import moment from 'moment'

// 연결제 사용자 인지 판단
export function vaildYearMember(date: string | null) {
    if (!date) return false
    return date >= moment().format('YYYY-MM-DD') 
}